import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"#5650DC\" fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m0 1a6 6 0 1 0 0 12A6 6 0 0 0 7 1\"></path><g transform=\"translate(4 4)\"><rect width=\"6\" height=\"1.333\" y=\"2.333\" rx=\".417\"></rect><path d=\"M3.667.417v5.166c0 .23-.187.417-.417.417h-.5a.417.417 0 0 1-.417-.417V.417c0-.23.187-.417.417-.417h.5c.23 0 .417.187.417.417\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }